import toCamelCase from '../strings/toCamelCase';
import toHyphenCase from '../strings/toHyphenCase';

const findParentComponent = (componentInstance, camelTag, hyphenTag) => {
  if (
    componentInstance.$vnode
    && componentInstance.$vnode.tag
    && (componentInstance.$vnode.tag.endsWith(camelTag)
      || componentInstance.$vnode.tag.endsWith(hyphenTag))
  ) {
    return componentInstance;
  }

  if (componentInstance.$parent) {
    return findParentComponent(componentInstance.$parent, camelTag, hyphenTag);
  }

  return null;
};

export default (componentInstance, tag) => findParentComponent(
  componentInstance,
  toCamelCase(tag),
  toHyphenCase(tag),
);
